import { render, staticRenderFns } from "./ToggleAllowErrors.vue?vue&type=template&id=3f39b6c0&scoped=true"
import script from "./ToggleAllowErrors.vue?vue&type=script&lang=ts"
export * from "./ToggleAllowErrors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f39b6c0",
  null
  
)

export default component.exports